import { createFileRoute } from '@tanstack/react-router';
import { FormacaoPage, lerBuscaFormacao } from '@/components/formacao';

export const Route = createFileRoute('/_app/precificar/formacao')({
  validateSearch: (bruto: Record<string, unknown>) => lerBuscaFormacao(bruto),
  component: FormacaoRota,
});

function FormacaoRota() {
  const busca = Route.useSearch();
  return <FormacaoPage key={`${busca.itemId ?? ''}|${busca.tabelaId ?? ''}|${busca.condicaoId ?? ''}|${busca.praticado ?? ''}`} inicial={busca} />;
}
